// src/app/state/actions/try-it.actions.ts
import { createAction, props } from '@ngrx/store';
import { TryItProxyRequest$Params } from '@api/fn/try-it/try-it-proxy-request';
import { ApiDefTryItRequestData } from '@api/index';
import { TryItGetRequestHistory$Params } from '@api/fn/try-it/try-it-get-request-history';

export const setSelectedLanguage = createAction(
  '[TryIt] Set Selected Language',
  props<{ languageTitle: string }>()
);

export const setSelectedCodeGenerator = createAction(
  '[TryIt] Set Selected Code Generator',
  props<{ codeGeneratorCode: string }>()
);

export const setSelectedServer = createAction(
  '[TryIt] Set Selected Server',
  props<{ url: string }>()
);

// Action to set API Key credentials
export const setApiKeyCredential = createAction(
  '[TryIt] Set API Key Credential',
  props<{ name: string; value: string }>()
);

// Action to set HTTP credentials
export const setHttpCredentials = createAction(
  '[TryIt] Set HTTP Credentials',
  props<{ scheme: string; token: string }>()
);

// Action to set OAuth2 credentials
export const setOAuth2Credentials = createAction(
  '[TryIt] Set OAuth2 Credentials',
  props<{
    flowName: string;
    accessToken: string;
    refreshToken: string;
    scopes: string[];
  }>()
);

// Action to set OpenID Connect credentials
export const setOpenIdCredentials = createAction(
  '[TryIt] Set OpenID Connect Credentials',
  props<{ idToken: string; refreshToken: string }>()
);

// Action to set the active auth tab index
export const setActiveAuthSecurityRequirement = createAction(
  '[TryIt] Set Active Auth Security Requirement',
  props<{ index: number; requirementKey: string }>()
);

// Action to set the Try It History panel open/collapsed state
export const setTryItHistoryPanelOpen = createAction(
  '[TryIt] Set Try It History Panel Open',
  props<{ open: boolean }>()
);

// TryIt Proxy Request Actions
export const tryItProxyRequest = createAction(
  '[TryIt] Proxy Request',
  props<{ params: TryItProxyRequest$Params }>()
);

export const tryItProxyRequestSuccess = createAction(
  '[TryIt] Proxy Request Success',
  props<{ response: ApiDefTryItRequestData }>()
);

export const tryItProxyRequestFailure = createAction(
  '[TryIt] Proxy Request Failure',
  props<{ error: string }>()
);

export const resetTryItProxyRequest = createAction(
  '[TryIt] Reset Proxy Request'
);

export const setCurrentSelectedRequest = createAction(
  '[TryIt] Set Current Selected Request',
  props<{ requestId: string | null }>()
);

// TryIt Get Request History Actions
export const loadRequestHistory = createAction(
  '[TryIt] Load Request History',
  props<{ params?: TryItGetRequestHistory$Params }>()
);

export const loadRequestHistorySuccess = createAction(
  '[TryIt] Load Request History Success',
  props<{ requests: ApiDefTryItRequestData[] }>()
);

export const loadRequestHistoryFailure = createAction(
  '[TryIt] Load Request History Failure',
  props<{ error: string }>()
);
